import RoutesMap from '../../../route_control/RouteControl.js'
import { Form, InputGroup, Button, Card } from 'react-bootstrap'
import { useFormik } from 'formik'
import { LoginSchema } from './ValidationSchema'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import { KeyRound, UserRound, Eye, EyeOff } from 'lucide-react'
import logo from '../../../assets/images/rexolms.png'
import { ButtonLoader } from '../../loader'
import { SessionManager } from '../../../utils'
import { signIn, sidebar } from '../../../redux/slices/assets'

export const LoginFormImport = {
    RoutesMap,
    Form,
    InputGroup,
    Button,
    Card,
    useFormik,
    LoginSchema,
    useNavigate,
    useDispatch,
    toast,
    KeyRound,
    UserRound,
    Eye,
    EyeOff,
    logo,
    ButtonLoader,
    SessionManager,
    signIn,
    sidebar,
}